import HashtagIcon from "../projectSpecificComponents/svgIcons/hashtag";

export const COST_CENTER_ICON = "mapsa-mortgage";
export const ACCOUNT_TITLE_ICON = "mapsa-blinder";
export const HOME_ICON = "mapsa-home";
export const ACCOUNT_REVIEW_ICON = "mapsa-growth";
export const COST_CLASSIFICATION_ICON = "mapsa-list-of-items";
export const IMPREST_ICON = "mapsa-cash";
export const CONTACT_ICON = "mapsa-phone-book";
export const HASHTAG_ICON = HashtagIcon;

export const USER_SETTING_ICON = "mapsa-user-1";
export const PROJECTS_MANAGEMENT_ICON = "mapsa-project";
export const PROJECT_SETTING_ICON = "mapsa-Project-2";
export const USER_MANAGEMENT_ICON = "mapsa-users-setting";
export const UPLOAD_FROM_EXCEL_ICON = "mapsa-xlsx-file-format";
export const BACKUP_ICON = "mapsa-backup";
export const ARCHIVE_FILES_ICON = "mapsa-inbox";
